import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetAvailableCustomFieldCountQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
}>;


export type GetAvailableCustomFieldCountQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, availableCustomFieldCount?: number | null } | null };


export const GetAvailableCustomFieldCount = /*#__PURE__*/ gql`
    query GetAvailableCustomFieldCount($accountId: ID!) {
  account(accountId: $accountId) {
    id
    availableCustomFieldCount
  }
}
    ` as unknown as DocumentNode<GetAvailableCustomFieldCountQuery, GetAvailableCustomFieldCountQueryVariables>;

          

          export const useGetAvailableCustomFieldCountQuery = (options?:QueryHookOptions<GetAvailableCustomFieldCountQuery, GetAvailableCustomFieldCountQueryVariables>) => useQuery(GetAvailableCustomFieldCount, options);

          

          export type GetAvailableCustomFieldCountQueryOptions = QueryHookOptions<GetAvailableCustomFieldCountQuery, GetAvailableCustomFieldCountQueryVariables>;

          

          export const useGetAvailableCustomFieldCountLazyQuery = (options?:LazyQueryHookOptions<GetAvailableCustomFieldCountQuery, GetAvailableCustomFieldCountQueryVariables>) => useLazyQuery(GetAvailableCustomFieldCount, options);

          

          export type GetAvailableCustomFieldCountQueryResult = ReturnType<typeof useGetAvailableCustomFieldCountQuery>;

          
